import React from 'react';
import { Provider } from 'react-redux';
import {
    BrowserRouter,
} from 'react-router';
import store from './store/store';
// import Stage from './components/sites/meta/Stage';
import SiteRouting from './SiteRouting';

const App: React.FC = () => {

    return (
        <Provider store={store}>
            <BrowserRouter>
                <div className='w-dvh h-dvh relative'>
                    {/* <Stage /> */}
                    <SiteRouting />
                </div>
            </BrowserRouter>
        </Provider>
    )
}

export default App;